import _ from 'lodash'
import Cesium from 'cesiumDll/Cesium'
import de from '../i18n/de'
import en from '../i18n/en'
import it from '../i18n/it'

export const earthRadiusKm = 6371 // Radius of the earth in km

// distance helper
export const getDistance = (lon1, lat1, lon2, lat2) => {
  const R = earthRadiusKm
  const dLat = Cesium.Math.toRadians(lat2-lat1)
  const dLon = Cesium.Math.toRadians(lon2-lon1)
  const a = Math.sin(dLat/2) * 
    Math.sin(dLat/2) +
    Math.cos(Cesium.Math.toRadians(lat1)) * 
    Math.cos(Cesium.Math.toRadians(lat2)) * 
    Math.sin(dLon/2) * 
    Math.sin(dLon/2)
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a)) 
  const d = R * c // Distance in km
  return d
}

// angle helper
export const getAngle = (A,B,C) => {
  const AB = Math.sqrt(Math.pow(B.x-A.x,2)+ Math.pow(B.y-A.y,2))
  const BC = Math.sqrt(Math.pow(B.x-C.x,2)+ Math.pow(B.y-C.y,2))
  const AC = Math.sqrt(Math.pow(C.x-A.x,2)+ Math.pow(C.y-A.y,2))
  return Math.acos((BC*BC+AB*AB-AC*AC)/(2*BC*AB))
}

export const getLanguage = () => {
  let language = window.navigator.languages[0] || window.navigator.userLanguage

  return language ? language.split('-')[0].toLowerCase() : 'de'
}

export const __ = (key) => {
  let dict
  switch (getLanguage()) {

    case 'de' :
      dict = de
      break
      
    case 'it' :
      dict = it
      break
      
    case 'en' :
    default :
      dict = en
      break
  }

  return (_.has(dict, key) && _.get(dict, key) != '') ? _.get(dict, key) : _.get(en, key)
}


export const lng2tileX = (lng,zoom = 6) => { 
  return (Math.floor((lng+180)/360*Math.pow(2,zoom)))
}

export const lat2tileY = (lat,zoom = 6) => { 
  return (Math.floor((1-Math.log(Math.tan(lat*Math.PI/180) + 1/Math.cos(lat*Math.PI/180))/Math.PI)/2 *Math.pow(2,zoom)))
}

export const tileX2lng = (x,zoom = 6) => {
  return (x/Math.pow(2,zoom)*360-180)
}

export const tileY2lat = (y,zoom = 6) => {
  let n = Math.PI-2*Math.PI*y/Math.pow(2,zoom)
  return (180/Math.PI*Math.atan(0.5*(Math.exp(n)-Math.exp(-n))))
}


      
// dot color testing
export const lightblue = {
  fill: new Cesium.Color(215/255,238/255,251/255,1.0),
  outline: new Cesium.Color(215/255,238/255,251/255,0.15)
}

export const cdblue = {
  fill: new Cesium.Color(76/255,207/255,239/255,1.0),
  outline: new Cesium.Color(76/255,207/255,239/255,0.15)
}

export const yellow = {
  fill: new Cesium.Color(249/255,203/255,71/255,1.0),
  outline: new Cesium.Color(249/255,203/255,71/255,0.15)
}

export const red = {
  fill: new Cesium.Color(219/255,68/255,55/255,1.0),
  outline: new Cesium.Color(219/255,68/255,55/255,0.15)
}

export const orange = {
  fill: new Cesium.Color(239/255,154/255,76/255,1.0),
  outline: new Cesium.Color(239/255,154/255,76/255,0.15)
}

export const skin = {
  fill: new Cesium.Color(241/255,171/255,137/255,1.0),
  outline: new Cesium.Color(241/255,171/255,137/255,0.15)
}

export const midblue = {
  fill: new Cesium.Color(149/255,224/255,242/255,1.0),
  outline: new Cesium.Color(149/255,224/255,242/255,0.15)
}

export const purewhite = {
  fill: new Cesium.Color(255/255,255/255,255/255,1.0),
  outline: new Cesium.Color(255/255,255/255,255/255,0.15)
}

export const palebanana = {
  fill: new Cesium.Color(249/255,227/255,151/255,1.0),
  outline: new Cesium.Color(249/255,227/255,151/255,0.2)
}

export const radiogreen = {
  fill: new Cesium.Color(0/255,255/255,116/255,1.0),
  outline: new Cesium.Color(0/255,255/255,116/255,0.2)
}


// WEBPACK FOOTER //
// ./src/lib/helpers.js